import styled from 'styled-components';

interface FormPageProps {
  children?: React.ReactElement<any>;
}

function FormPage({ children }: FormPageProps) {
  return (
    <FormPageWrapper>
      <Container>{children}</Container>
    </FormPageWrapper>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 24px;
`;

export default FormPage;

const FormPageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: row;
  height: 100%;
  min-height: 100%;
  padding: 24px 24px 0 24px;
  overflow: auto;
`;
